const q = require('queried');
const on = require('emmy/on');

const _ = require('./i18n');

class ListItemAddressList {
  constructor(el) {
    this.el = el;
    this.collapsed = true;
  }

  uncollapse() {
    q.all(['.address', '.addressItem'], this.el).forEach((address) => address.removeAttribute('hidden'));
    this.collapser.innerHTML = _('Hide');
    this.collapsed = false;
  }

  collapse() {
    q.all(['.address', '.addressItem'], this.el).slice(3).forEach((address) => address.setAttribute('hidden', 'hidden'));
    this.collapser.innerHTML = _('Show all addresses');
    this.collapsed = true;
  }

  toggleCollapse() {
    if (this.collapsed) {
      this.uncollapse();
    } else {
      this.collapse();
    }
  }

  init() {
    if (this.el.children.length <= 3) {
      return;
    }

    this.collapser = document.createElement('span');
    this.collapser.classList.add('collapser');

    this.collapse();

    this.el.appendChild(this.collapser);

    on(this.collapser, 'click', () => this.toggleCollapse());
  }
}

module.exports = ListItemAddressList;
